function createWebSocket(url) {
  // console.log(url,'url')
  var ws = null;
  try {
    if (!('WebSocket' in window)) {
      alert('您的浏览器不支持websocket的协议，建议使用新版谷歌、火狐等浏览器，请勿使用IE10以下浏览器，360浏览器请使用极速模式，不要使用兼容模式!');
      return;
    }
    if (!url) {
      console.warn('当前连接地址为空，无法建立连接！！！');
      return;
    }
    ws = new WebSocket(url);
    var params = {
      wsUrl: url,
      lockReconnect: false,
      dealMessageFunc: dealMessageFunc,
      heartCheck: heartCheck()
    };
    Object.assign(ws, params);
    // console.log(ws,url,'-------------')
    initEventHandle(ws, url);

    // 监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server断会抛异常
    window.onbeforeunload = function () {
      wsClose(ws);
    };
    return ws;
  } catch (e) {
    reconnect(ws, url);
    // console.log(e)
    return ws;
  }
}
function initEventHandle(ws, wsUrl) {
  ws.onclose = function () {
    if (ws.lockReconnect) {
      ws.heartCheck.reset();
      ws.close();
    } else reconnect(ws, wsUrl);
    console.info('llws3连接关闭!' + new Date().toUTCString());
  };
  ws.onerror = function () {
    reconnect(ws, wsUrl);
    console.warn('llws连接错误!');
  };
  ws.onopen = function () {
    ws.heartCheck.reset().start(ws); // 心跳检测重置
    console.info('llws连接成功!' + new Date().toUTCString());
  };
  ws.onmessage = function (event) {
    // console.log(JSON.parse(event.data),'收到服务端传递过来的数据 收到任何消息都是连接成功！！！')
    // 重置heartCount为0，并重置心跳定时器  如果出现异常情况：服务端无响应   客户端不会直接感知到本次ping失败  heartCount会持续累加  知道达到设定的上限 heartLimit: 5
    ws.heartCheck.reset().start(ws); // 拿到任何消息都说明当前连接是正常的
    ws.lockReconnect = false;
    ws.dealMessageFunc(JSON.parse(event.data));
  };
}
function dealMessageFunc(data) {
  return data;
}
function wsClose(ws) {
  if (!ws) return;
  if (!ws.lockReconnect) {
    ws.close();
    return;
  }
  ws.lockReconnect = true;
  ws.close();
}
function reconnect(ws, url) {
  ws.heartCheck.reset();
  if (ws.lockReconnect) return;
  ws.lockReconnect = true;
  setTimeout(function () {
    // 没连接上会一直重连，设置延迟避免请求过多
    ws = createWebSocket(url);
    ws.lockReconnect = false;
  }, 30000);
}

// 心跳检测
var heartCheck = function heartCheck() {
  return {
    timeout: 120000,
    // 2分钟发一次心跳
    timeoutObj: null,
    serverTimeoutObj: null,
    heartCount: 0,
    heartLimit: 5,
    reset: function reset() {
      this.heartCount = 0;
      clearTimeout(this.timeoutObj);
      clearTimeout(this.serverTimeoutObj);
      return this;
    },
    start: function start(ws) {
      var that = this;
      this.timeoutObj = setTimeout(function () {
        // 这里发送一个心跳，后端收到后，返回一个心跳消息，
        // onmessage拿到返回的心跳就说明连接正常
        if (that.heartCount === that.heartLimit) {
          console.error('连续5次心跳检测失败，关闭连接...');
          ws.close();
        }
        ws.send('ping');
        console.info('ping!');
        that.heartCount += 1;
      }, this.timeout);
    }
  };
};
var WS = {
  createWebSocket: createWebSocket,
  wsClose: wsClose,
  dealMessageFunc: dealMessageFunc
};
export default WS;